import whPlusLogoOnly from 'assets/images/plus-logo-only.svg';
import whPlusLogo from 'assets/images/plus-logo.svg';
import whLogo from 'assets/images/williamhill-logo-dark.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Accordion from '../../../components/common/Accordion';
import AccordionLandingHeader from '../../../components/common/Accordion/AccordionLandingHeader';
import Button from '../../../components/common/Button';
import { COOKIE, TERMS } from '../../../routes/paths';
import FormMessage from '../../FormMessage';
import { activateNewCard } from '../actions';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { landingImageUrls, whenTheFunStops } = contentStackImageUrls;

export const Landing = ({ nextStep }) => {
  const getStarted = (
    <div className="get-started">
      <Button
        className="get-started__button"
        onClick={nextStep}
      >
        Activate New Card
      </Button>
    </div>
  );

  const { footballBg, footballBgMobile, horseBg, exploreImage1, exploreImage2, exploreImage3 } = landingImageUrls;

  return (
    <div>
      <div className="landing-page">
        <div className="landing-page__container">
          <FormMessage className="landing-page__form-message" slotId="app_errors" />
          <FormMessage className="landing-page__form-message" />
        </div>
        <div className="landing-page-header">
          <div className="landing-page__container">
            <div className="landing-page-header__content-wrapper">
              <img
                src={footballBg}
                onError={(e) => { e.target.src = '../../../../assets/images/landing/Robbie_Asset_598x634.png'; }}
                className="landing-page-header__background landing-page-header__background--desktop"
              />
              <img
                src={footballBgMobile}
                onError={(e) => { e.target.src = '../../../../assets/images/landing/Robbie_Asset_290x489.png'; }}
                className="landing-page-header__background landing-page-header__background--mobile"
              />
              <div className="landing-page-header__content-left">
                <div className="landing-page-header__get-more landing-get-more">
                  <img src={whPlusLogo} alt="William Hill Plus" className="whp-logo" />
                </div>
                <div
                  className="landing-page-header__content landing-page-header__content--activate"
                >
                  <h2>Cash in shop bets on your mobile</h2>
                  <h3>Live scores & <span>in-game</span> stats</h3>
                  <h3>Free bets & regular offers</h3>
                  {getStarted}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-page-newest">
          <div className="landing-page-newest__background">
            <img
              className="landing-page-newest__background-img"
              src={horseBg}
              onError={(e) => { e.target.src = '../../../../assets/images/landing/horse-bg.png'; }}
            />
          </div>
          <div className="landing-page__container">
            <h2 className="landing-page-newest__header">
              Now{' '}
              <img
                src={whPlusLogoOnly}
                alt="Plus"
                className="landing-page-newest__plus-logo-only"
              /> gives you even more...
            </h2>
            <ul className="landing-page-newest__list">
              <li className="landing-page-newest__item">
                Withdraw online funds as cash in shop
              </li>
              <li className="landing-page-newest__item">
                Bet with online funds in shop
              </li>
            </ul>
          </div>
        </div>

        <div className="landing-page-rg">
          <div className="landing-page__container">
            <Accordion
              header={AccordionLandingHeader}
              headerText="William Hill supports responsible gambling"
            >
              <div className="landing-page-rg__content">
                <p>
                  The William Hill Plus app allows you to remotely monitor your gambling away from
                  the shop which may be something you would prefer to avoid. If you are
                  self-excluded from any William Hill shop or online service, have any concerns
                  about your gambling, or you would like some advice around gambling
                  responsibly, we would encourage you to speak to a member of the shop
                  team before completing your registration.
                </p>
                <p>
                  For information, help and support, visit{' '}
                  <a
                    className="landing-page__link"
                    href="http://www.gambleaware.co.uk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GambleAware
                  </a>
                  {' '}or call the National Gambling Helpline on Freephone{' '}
                  <a
                    className="landing-page__link"
                    href="tel:448088020133"
                  >
                    0808 802 0133
                  </a>
                  .
                </p>
              </div>
            </Accordion>
            <div className="landing-page-rg__description">
              <a
                href="http://www.whenthefunstops.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={whenTheFunStops}
                  onError={(e) => { e.target.src = '../../../../assets/images/when-the-fun-stops.svg'; }}
                  alt="When the fun stops"
                />
              </a>
              <p>
                By using this service, you agree to our{' '}
                <Link
                  to={TERMS}
                  className="landing-page__link"
                >
                  T&amp;Cs
                </Link>
                {' '}and confirm you are 18+. Visit the{' '}
                <Link
                  to={COOKIE}
                  className="landing-page__link"
                >
                  cookie policy
                </Link>
                {' '}to learn how we use cookies.
              </p>
            </div>
          </div>
        </div>
        <div className="landing-page-explore">
          <div className="landing-page__container">
            <div className="landing-page-explore__content">
              <div className="landing-page-explore__row">
                <div className="landing-page-explore__content-element">
                  <i className="icon icon--data landing-page-explore__icon" alt="" />
                  <p>Cash-in your shop bets anytime on your mobile</p>
                  <div className="landing-page-explore__image-wrapper">
                    <img
                      className="landing-page-explore__image"
                      src={exploreImage1}
                      onError={(e) => { e.target.src = '../../../../assets/images/landing/explore-image-1.jpg'; }}
                      alt=""
                    />
                  </div>
                </div>
                <div className="landing-page-explore__content-element">
                  <i className="icon icon--withdraw landing-page-explore__icon" alt="" />
                  <p>Use your online funds + withdraw & deposit in shop</p>
                  <div className="landing-page-explore__image-wrapper">
                    <img
                      className="landing-page-explore__image"
                      src={exploreImage2}
                      onError={(e) => { e.target.src = '../../../../assets/images/landing/explore-image-2.jpg'; }}
                      alt=""
                    />
                  </div>
                </div>
                <div className="landing-page-explore__content-element">
                  <i className="icon icon--chart landing-page-explore__icon" alt="" />
                  <p>Follow all the action with live scores & in-depth stats</p>
                  <div className="landing-page-explore__image-wrapper">
                    <img
                      className="landing-page-explore__image"
                      src={exploreImage3}
                      onError={(e) => { e.target.src = '../../../../assets/images/landing/explore-image-3.jpg'; }}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              {getStarted}
            </div>
          </div>
        </div>
        <div className="landing-page-footer">
          <div className="landing-page__container">
            <div className="landing-page-footer__content">
              <p>Copyright © William Hill plc {new Date().getFullYear()}. All rights reserved.</p>
              <img className="landing-page-footer__wh-logo" src={whLogo} alt="William Hill" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Landing.propTypes = {
  nextStep: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  nextStep: activateNewCard
};

export default connect(null, mapDispatchToProps)(Landing);
